import qs from "qs";

export class Redeem {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/redeem`;
  }

  async getUniqueCostCenterFromTransaction() {
    const url = `${this.baseURL}/shop/unique-cost-center`;
    const response = await this.httpClient.request("get", url);
    return response;
  }

  async getRedeemTransactionReport (params, type) {
    const query = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/shop/report/${type}${query}`;
    const response = await this.httpClient.request("get", url);
    return response;
  }

  async downloadRedeemTransactionReport(params, type) {
    const query = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/shop/report/${type}/download${query}`;
    const config = {
      headers: {
        Accept: "application/octet-stream",
      },
      responseType: "blob"
    }
    const response = await this.httpClient.request("get", url, config);
    return response;
  }
}
